export var EXTERNAL_RESOURCE;
(function (EXTERNAL_RESOURCE) {
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["CSS_LEAFLET"] = 0] = "CSS_LEAFLET";
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["CSS_LEAFLET_CLUSTER"] = 1] = "CSS_LEAFLET_CLUSTER";
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["CSS_LEAFLET_CLUSTER_DEFAULT"] = 2] = "CSS_LEAFLET_CLUSTER_DEFAULT";
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["JS_GOOGLE_MAPS"] = 3] = "JS_GOOGLE_MAPS";
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["JS_LEAFLET"] = 4] = "JS_LEAFLET";
    EXTERNAL_RESOURCE[EXTERNAL_RESOURCE["JS_LEAFLET_CLUSTER"] = 5] = "JS_LEAFLET_CLUSTER";
})(EXTERNAL_RESOURCE || (EXTERNAL_RESOURCE = {}));
